import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FaBars, FaComment, FaChartBar, FaSignOutAlt, FaUsers, FaQuestionCircle } from "react-icons/fa";
import { API_BASE, apiFetch } from '../lib/api';
import { clearBrowserStorage } from '../lib/storage';
import { useAuth } from '../context/AuthContext';

const SideMenu: React.FC<{ role: 'admin' | 'agent' | null }> = ({ role }) => {
    const navigate = useNavigate();
    const { setAuthUser } = useAuth();
    const [isCollapsed, setIsCollapsed] = useState(() => {
        const storedValue = localStorage.getItem('sideMenuCollapsed') || 'true';
        return storedValue === 'true';
    });

    const toggleCollapse = () => {
        localStorage.setItem('sideMenuCollapsed', !isCollapsed ? 'true' : 'false')
        setIsCollapsed(!isCollapsed);
    };

    const handleLogout = async () => {
        try {
            await apiFetch(`${API_BASE}/api/auth/logout`, { method: 'POST' });
        } catch {
            // noop
        } finally {
            clearBrowserStorage();
            setAuthUser(null);
            navigate('/', { replace: true });
        }
    };

    return (
        <div className={`h-screen bg-white text-gray-800 p-4 flex flex-col flex-shrink-0 shadow-lg transition-all duration-300 ${isCollapsed ? 'w-20' : 'w-64'}`}>
            <div>
                <div className={`flex items-center mb-4 ${isCollapsed ? 'justify-center' : 'justify-between'}`}>
                    <img src={'/images/logo_256.png'} alt="Filtron Logo" className={`w-32 ${isCollapsed ? 'hidden' : 'block'}`} />
                    <div className='flex flex-col items-center'>
                        {isCollapsed && (
                            <img src={'/images/logo_256.png'} alt="Filtron Logo" className="w-8 mb-2" />
                        )}
                        <button onClick={toggleCollapse} className="text-gray-800 hover:text-gray-600 cursor-pointer">
                            <FaBars />
                        </button>
                    </div>
                </div>
                <ul className='mt-5'>
                    <li data-tooltip-content={"Chat"} data-tooltip-id='my-tooltip'>
                        <NavLink
                            to="/chat"
                            className={({ isActive }) =>
                                `flex items-center py-2 px-4 rounded ${isActive ? 'bg-gray-700 text-white shadow-md' : 'hover:bg-gray-100'} ${isCollapsed ? 'justify-center' : ''}`
                            }
                        >
                            <FaComment className={`${!isCollapsed ? 'mr-2' : ''}`} />
                            {!isCollapsed && 'Chat'}
                        </NavLink>
                    </li>
                    {role !== 'agent' && (
                        <li data-tooltip-content={"Analytics"} data-tooltip-id='my-tooltip'>
                            <NavLink
                                to="/analytics"
                                className={({ isActive }) =>
                                    `flex items-center py-2 px-4 rounded ${isActive ? 'bg-gray-700 text-white shadow-md' : 'hover:bg-gray-100'} ${isCollapsed ? 'justify-center' : ''}`
                                }
                            >
                                <FaChartBar className={`${!isCollapsed ? 'mr-2' : ''}`} />
                                {!isCollapsed && 'Analytics'}
                            </NavLink>
                        </li>
                    )}
                    {role !== 'agent' && (
                        <li data-tooltip-content={"Team Members"} data-tooltip-id='my-tooltip'>
                            <NavLink
                                to="/team_members"
                                className={({ isActive }) =>
                                    `flex items-center py-2 px-4 rounded ${isActive ? 'bg-gray-700 text-white shadow-md' : 'hover:bg-gray-100'} ${isCollapsed ? 'justify-center' : ''}`
                                }
                            >
                                <FaUsers className={`${!isCollapsed ? 'mr-2' : ''}`} />
                                {!isCollapsed && 'Team Members'}
                            </NavLink>
                        </li>
                    )}
                    {role !== 'agent' && (
                        <li data-tooltip-content={"FAQs"} data-tooltip-id='my-tooltip'>
                            <NavLink
                                to="/faq_manager"
                                className={({ isActive }) =>
                                    `flex items-center py-2 px-4 rounded ${isActive ? 'bg-gray-700 text-white shadow-md' : 'hover:bg-gray-100'} ${isCollapsed ? 'justify-center' : ''}`
                                }
                            >
                                <FaQuestionCircle className={`${!isCollapsed ? 'mr-2' : ''}`} />
                                {!isCollapsed && 'FAQs'}
                            </NavLink>
                        </li>
                    )}
                </ul>
            </div>
            <ul className="mt-auto">
                <li>
                    <button
                        onClick={handleLogout}
                        className={`w-full flex items-center py-2 px-4 rounded hover:bg-gray-100 cursor-pointer ${isCollapsed ? 'justify-center' : ''}`}
                    >
                        <FaSignOutAlt className={`${!isCollapsed ? 'mr-2' : ''}`} />
                        {!isCollapsed && 'Logout'}
                    </button>
                </li>
            </ul>
        </div>
    );
};

export default SideMenu;
